export default __webpack_public_path__ + "static/media/3.bf07562c.jpg";